export function calcPlates(target, bar = 45) {
  const avail = [45, 35, 25, 10, 5, 2.5];
  let perSide = (target - bar) / 2;
  if (perSide <= 0) return [];
  const res = [];
  for (const p of avail) { while (perSide >= p) { res.push(p); perSide -= p; } }
  return res;
}

export function calc1RM(weight, reps) {
  if (reps <= 0) return weight;
  if (reps === 1) return weight;
  return Math.round(weight * (1 + reps / 30));
}
